//Third Party Libraries
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/24/solid';
import type { ChangeEvent } from 'react';
import { twMerge } from 'tailwind-merge';

export default function TableFooter({
  currentPage,
  totalPage,
  perPageHandler,
  pageChangeHandler,
}: {
  currentPage: number;
  totalPage: number;
  perPageHandler: (v: ChangeEvent<HTMLSelectElement>) => void;
  pageChangeHandler: (direction: string) => void;
}) {
  return (
    <div className='flex bg-white w-full justify-end py-5 border-t text-neutralColor-normal text-sm'>
      <div className='flex justify-around gap-4 items-end font-semibold px-5'>
        <div>
          Rows per page:{' '}
          <select className='bg-white border rounded-md px-2 py-1' onChange={perPageHandler} defaultValue={10}>
            <option>5</option>
            <option>10</option>
            <option>15</option>
            <option>20</option>
          </select>
        </div>
        <div>
          {currentPage} of {totalPage}
        </div>
        <div className='flex gap-2'>
          <div
            className={`text-white cursor-pointer flex justify-center items-center rounded p-0.5 ${
              currentPage === 1 ? 'bg-neutralColor-light' : 'bg-primaryColor-normal hover:bg-primaryColor-medium'
            }`}
            id='prev'
            onClick={() => pageChangeHandler('prev')}
          >
            <ChevronLeftIcon className='h-5 w-5' />
          </div>
          <div
            className={twMerge([
              'text-white cursor-pointer flex justify-center items-center rounded p-0.5',
              currentPage === totalPage ? 'bg-neutralColor-light' : 'bg-primaryColor-normal hover:bg-primaryColor-medium',
            ])}
            onClick={() => pageChangeHandler('next')}
          >
            <ChevronRightIcon className='h-5 w-5' />
          </div>
        </div>
      </div>
    </div>
  );
}
